/* Made to order: the customer agrees to the wait before the piece is bought (Thom, 14 Oct 2026).

   TWO JOBS
   1. The product page. An add-to-basket form carrying an unticked agreement
      (snippets/made-to-order-accept.liquid) is refused before the theme sees it.
      The theme's product form is novalidate and posts by fetch from its own
      submit listener on the form, so `required` would do nothing; this listener
      sits on the document in the CAPTURE phase, which runs before any listener on
      the form itself, and stops the event there.
   2. The basket. A made-to-order line that arrived without the agreement (a quick
      add we have not found, a /cart/add permalink, an old tab) shows "I agree to
      the wait" on the line (snippets/cart-line-items.liquid). Pressing it rewrites
      that line's properties through /cart/change.js, keeping any it already had,
      and refreshes the basket so the checkout block lifts.

   THIS IS THE FIRST GATE, NOT THE ONLY ONE. snippets/cart-options-guard.liquid
   disables checkout server-side while any made-to-order line lacks the agreement,
   so the rule holds with JavaScript off or erroring. Safe to load more than once. */

(function () {
  'use strict';

  if (window.PH_MTO_LOADED) return;
  window.PH_MTO_LOADED = true;

  // form.elements includes controls joined through the form attribute, which is
  // how the agreement sits under the callouts, outside the form. Never form.id:
  // the product form has an input named "id", so form.id is that input.
  function inputFor(form) {
    var els = form.elements || [];
    for (var i = 0; i < els.length; i++) {
      if (els[i].hasAttribute && els[i].hasAttribute('data-mto-input')) return els[i];
    }
    return null;
  }

  function showError(input, on) {
    var box = input.closest('[data-mto-accept]');
    if (!box) return;
    var error = box.querySelector('[data-mto-error]');
    box.classList.toggle('is-invalid', on);
    if (error) error.hidden = !on;
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var input = inputFor(form);
      if (!input || input.checked) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      showError(input, true);
      var box = input.closest('[data-mto-accept]') || input;
      if (box.scrollIntoView) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      input.focus({ preventScroll: true });
    },
    true
  );

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.matches && input.matches('[data-mto-input]') && input.checked) {
      showError(input, false);
    }
  });

  /* ------------------------------------------------------------- basket */

  // Capture phase: the basket's own item listeners stop clicks before they
  // bubble to the document, which left this button dead in testing.
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-mto-line-accept]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.disabled) return;
    button.disabled = true;

    var key = button.getAttribute('data-line-key');
    var name = button.getAttribute('data-property-name');
    var value = button.getAttribute('data-property-value');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var line = (cart.items || []).filter(function (item) {
          return item.key === key;
        })[0];
        if (!line) throw new Error('line gone');
        var properties = {};
        Object.keys(line.properties || {}).forEach(function (k) {
          if (line.properties[k] !== null && line.properties[k] !== '') properties[k] = line.properties[k];
        });
        properties[name] = value;
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: line.quantity, properties: properties }),
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('change refused');
        if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        }
      })
      .catch(function () {
        button.disabled = false;
        window.location.reload();
      });
  }, true);
})();
